import React, {useState} from 'react';
import {CurrencyDollarIcon, CurrencyEuroIcon, CurrencyPoundIcon} from "@heroicons/react/outline";
import {Icon} from "types/Icon";
import {concatenate} from "../../../services/string";

enum Currency {GBP = '£', USD = '$', EUR = '€'}

type Props = {
    currency?: Currency | string
    value?: number
    disabled?: boolean
    onChange: (amount?: number) => any
    min?: number
    max?: number
    required?: boolean
}

const currencyIcons: Record<Currency, Icon> = {
    [Currency.GBP]: CurrencyPoundIcon,
    [Currency.USD]: CurrencyDollarIcon,
    [Currency.EUR]: CurrencyEuroIcon,
}

function MoneyInput(props: Props) {
    const [amountString, setAmountString] = useState<string>(props.value? (props.value / 100).toFixed(2) : '0.00');

    const handleChangeValue = (event: React.FormEvent<HTMLInputElement>) => {
        let valueString = event.currentTarget.value
        let valueNumber = parseFloat(valueString)

        setAmountString(valueString)
        props.onChange(Math.round(valueNumber * 100))
    }

    const handleBlur = (event: React.FormEvent<HTMLInputElement>) => {
        let valueNumber = parseFloat(event.currentTarget.value)
        if(isNaN(valueNumber)) valueNumber = 0

        setAmountString(valueNumber.toFixed(2))
        props.onChange(Math.round(valueNumber * 100))
    }

    const hasIcon = props.currency ? props.currency in currencyIcons : false;
    const Icon = currencyIcons[props.currency as Currency];

    return (
        <div className="relative rounded-md shadow-sm">
            {Icon &&
                <div className="absolute inset-y-0 left-0 pl-3 r-10 flex items-center pointer-events-none">
                    <Icon className="h-5 w-5 text-gray-400" aria-hidden="true" />
                </div>
            }

            <input type="number"
                   step='any'
                   autoComplete="off"
                   className={concatenate(props.disabled && 'text-gray-300', hasIcon && 'pl-10', 'focus:ring-brand focus:border-brand block sm:text-sm border-gray-300 rounded-md w-full')}
                   value={amountString}
                   onChange={handleChangeValue}
                   onBlur={handleBlur}
                   disabled={props.disabled}
                   min={props.min}
                   max={props.max}
                   required={props.required}
            />
        </div>
    );
}

MoneyInput.Currency = Currency

export default MoneyInput;